import React, { useState } from "react";

const GENDERS = [
  { label: "Soy Mujer", value: "mujer" },
  { label: "Soy Hombre", value: "hombre" },
  { label: "Otros", value: "otros" },
];

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export default function ActualizarPerfilYPostularATicketGratis({ LogoEmpresa, openPoliticasYPostular }) {
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    RUT: "",
    Genero: "",
    nombre: "",
    apellidos: "",
    day: "1",
    month: "Enero",
    year: "2000",
    whatsapp: "",
    email: "",
    instagram: "",
  });
  // Validación básica
  const validate = () => {
    const newErrors = {};
    if (!form.email) {
      newErrors.email = "El email es obligatorio";
    }
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "El email no es válido";
    }
    if (form.email && form.email.length > 50) {
      newErrors.email = "El email no puede tener más de 50 caracteres";
    }
    return newErrors;
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      // Aquí iría la lógica de registro
      alert("Información actualizada!");
    }
    openPoliticasYPostular();
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 bg-aw-bgbluedark-30 rounded-lg max-h-[90vh] overflow-hidden shadow-lg">
      <div className="hidden sm:block">
        <img
          src={LogoEmpresa}
          alt="Sign In"
          className="w-full h-full object-cover object-center rounded-t-2xl sm:rounded-l-rounded-t-2xl"
        />
      </div>
      <div
        className={`p-8 flex flex-col justify-center bg-aw-bluedark rounded-b-rounded-t-2xl sm:rounded-r-rounded-t-2xl text-white relative`}
      >
        {/* Mobile background image with overlay */}
        <div className="absolute inset-0 sm:hidden">
          <img
            src={LogoEmpresa}
            alt="Sign In"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-aw-bluedark-75 backdrop-blur-[1.5px]" />
        </div>
        <div className="relative z-10">
          <h4 className="text-xl font-bold mb-4">
            Completa el formulario para postular al ticket gratis
          </h4>
          <form
            onSubmit={handleSubmit}
            className="space-y-2 overflow-auto scrollbar-box"
          >
            <label className="block mb-1 font-medium text-xs" htmlFor="genero">
              Genero
            </label>
            <div className="flex justify-center gap-4 my-1">
              {GENDERS.map((g) => (
                <label
                  key={g.value}
                  className="flex items-center gap-2 text-white"
                >
                  <input
                    type="radio"
                    name="gender"
                    value={g.value}
                    checked={form.gender === g.value}
                    onChange={handleChange}
                    className="accent-aw-green"
                  />
                  {g.label}
                </label>
              ))}
            </div>

            <div className="flex gap-2">
              <div className="flex-1">
                <label
                  className="block mb-1 font-medium text-xs"
                  htmlFor="nombre"
                >
                  Nombre
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={form.nombre}
                  onChange={handleChange}
                  className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                  maxLength={30}
                  autoComplete="off"
                />
              </div>
              <div className="flex-1">
                <label
                  className="block mb-1 font-medium text-xs"
                  htmlFor="apellidos"
                >
                  Apellidos
                </label>
                <input
                  type="text"
                  id="apellidos"
                  name="apellidos"
                  value={form.apellidos}
                  onChange={handleChange}
                  className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                  maxLength={40}
                  autoComplete="off"
                />
              </div>
            </div>
            <label
              className="block mb-1 font-medium text-xs"
              htmlFor="fechaNacimiento"
            >
              Fecha de Nacimiento
            </label>
            <div className="flex justify-between gap-2">
              <input
                type="number"
                name="day"
                min="1"
                max="31"
                value={form.day}
                onChange={handleChange}
                className="w-1/5 rounded-lg px-2 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
              />
              <select
                name="month"
                value={form.month}
                onChange={handleChange}
                className="w-3/5 rounded-lg px-2 py-1 bg-white/90 text-black focus:outline-none focus:ring-2 focus:ring-aw-green"
              >
                {MONTHS.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <input
                type="number"
                name="year"
                min="1900"
                max={new Date().getFullYear()}
                value={form.year}
                onChange={handleChange}
                className="w-1/5 rounded-lg px-2 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-xs" htmlFor="RUT">
                RUT
              </label>
              <input
                type="text"
                id="RUT"
                name="RUT"
                value={form.RUT}
                onChange={handleChange}
                className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                maxLength={12}
                autoComplete="off"
                placeholder="12345678-9"
              />
            </div>
            <div>
              <label
                className="block mb-1 font-medium text-xs"
                htmlFor="whatsapp"
              >
                WhatsApp
              </label>
              <input
                type="tel"
                id="whatsapp"
                name="whatsapp"
                value={form.whatsapp}
                onChange={handleChange}
                className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                maxLength={15}
                autoComplete="off"
                placeholder="+56912345678"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-xs" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                maxLength={50}
                autoComplete="off"
                // required
                placeholder="example@example.com"
              />
              {errors.email && (
                <span className="text-red-400 text-xs">{errors.email}</span>
              )}
            </div>
            <div>
              <label
                className="block mb-1 font-medium text-xs"
                htmlFor="instagram"
              >
                Instagram
              </label>
              {/* TODO: Hacer que al momento de escribir la primera letra se escriba un "@" */}
              <input
                type="text"
                id="instagram"
                name="instagram"
                value={form.instagram}
                onChange={handleChange}
                className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                maxLength={30}
                autoComplete="off"
                placeholder="usuario"
              />
            </div>
            <button
              type="submit"
              className="w-full py-2 mt-4 bg-aw-green text-aw-bluedark font-bold rounded hover:scale-95 duration-300 transition-scale"
            >
              Actualizar y Postular
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
